import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation22({ animation, badge, all_animations }: Props) {
  const [isFlipped, setIsFlipped] = useState(false)
  const [showText, setShowText] = useState(false)

  useEffect(() => {
    setTimeout(() => setIsFlipped(true), 500)
    setTimeout(() => setShowText(true), 1500)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        .flip-card {
          perspective: 1000px;
        }
        .flip-card-inner {
          transition: transform 1s cubic-bezier(0.4, 0, 0.2, 1);
          transform-style: preserve-3d;
        }
        .flip-card-inner.flipped {
          transform: rotateY(180deg);
        }
        .flip-card-front, .flip-card-back {
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }
        .flip-card-back {
          transform: rotateY(180deg);
        }
        @keyframes cardShine {
          0% { left: -100%; }
          100% { left: 200%; }
        }
        .card-shine::after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 50%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          animation: cardShine 2s ease-in-out infinite;
          animation-delay: 1s;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* Flip Card */}
        <div className="flip-card w-48 h-56">
          <div className={`flip-card-inner relative w-full h-full ${isFlipped ? 'flipped' : ''}`}>
            {/* Face avant (dos de la carte) */}
            <div className="flip-card-front absolute w-full h-full bg-gradient-to-br from-tessan-green-hover to-tessan-green rounded-2xl flex items-center justify-center border-4 border-tessan-yellow/30">
              <div className="text-6xl">❓</div>
              <div className="absolute inset-0 rounded-2xl border-8 border-tessan-cream/10" />
            </div>

            {/* Face arrière (badge) */}
            <div className="flip-card-back absolute w-full h-full bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50 card-shine overflow-hidden">
              <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
            </div>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-700 ${showText ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
